/* tslint:disable */
// Source of truth: js/mk/autogenerated/bzCategories.ts (regenerated per server).
export const PRAMS_SLUG = "kocarky";
export const FOOTWEAR_SLUG = "obuv";
export const TOYS_SLUG = "hracky";
